import Checkmark from 'components/Icons/Checkmark';
import Close from 'components/Icons/Close';
import Customize from 'components/Icons/Customize';
import { frameSizeConst } from 'constants/frameSize';
import React, {  useMemo } from 'react';
import { useGlassesStore } from 'zus/glassesStore';
import { ColorTaxonomyType } from '../../constants/dataTypes';
import Button from 'components/Button/Button';
import { parseAsString, useQueryState } from 'nuqs'
import dynamic from 'next/dynamic';
import { ArmsOptionWithHex, ProductOptionsWithHex } from 'constants/dataDresdenTypes';
// Dynamically import UITooltip with ssr disabled
const UITooltip = dynamic(() => import('components/Others/UITooltip'), { ssr: false });

export default function ColorSizeArmsComponent({
	frameColor,
	frameArmsOptions,
	checkVariationOnColorPicker,
}: {
	frameArmsOptions: ProductOptionsWithHex;
	frameColor: string;
	checkVariationOnColorPicker?: Function;
}) {


	const [armColorQuery, setArmColorQuery] = useQueryState('armColor');

	const armColor = armColorQuery ?? frameColor;
	
	const colorList = frameArmsOptions?.arms_options ?? null;
	

	const armsSize = useGlassesStore((state) => state.arms_size);
	const setArmsColor = useGlassesStore((state) => state.setArmsColor);
	const setArmsSize = useGlassesStore((state) => state.setArmsSize);

	const selectedColorName = useMemo(() => {
		if(armColor) {
			const color = colorList?.find((e) => e.slug == armColor);
			if (color) {
				setArmsColor(armColor);
				return color.name;
			}
		}
		return '';
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [armColor]);

	if(!armColorQuery) {
		return null;
	}

	return  (
		<div className="w-full select-none mb-6">
			<div className="overflow-hidden bg-body">
				<div className="flex flex-col gap-6">
					<div className="flex flex-col gap-4">
						<div className="flex items-center justify-left">
							<h5 className="text-black font-medium text-[0.8rem] font-sans">
								Arms, <span className="text-[#959595]">{selectedColorName}</span>
							</h5>
							<button
								onClick={() => {
									setArmColorQuery(null);
								}}
								className="flex w-[69px] gap-[6px] h-[26px] justify-center items-center px-[9px] py-[6px] rounded-full ml-2"
								style={{ "background": "rgba(255, 199, 0, 0.2)" }}
							>
								<Close fill='#616161' width={9} height={9} />
								<p className="text-xs text-[#616161]"> Cancel </p>
							</button>
						</div>
						<div className="hide-scroll flex tsm:flex-wrap overflow-auto w-full gap-x-1.5 gap-y-2">
							{colorList &&
								colorList.map((e:ArmsOptionWithHex, i: number) => (
									<UITooltip key={i} id={`color-tooltip-${i}`} delay="20" place="top" message={e.name} messageWrapperClassName={'text-black'} tooltipWrapperClassName={'!rounded-[4px] border !border-[#E2E2E2] border-solid !bg-white shadow-tooltipSecondary white-tip'}>
										<div
											key={i}
											onClick={() => {
												setArmColorQuery(e.slug);
											}}
											className={`flex items-center justify-center min-w-[30px] h-[30px] cursor-pointer rounded-full ${armColorQuery == e.slug
													? ''
													: 'border border-brand-grey200 p-[3px]'
												}`}>
											{armColor == e.slug ?
												<div
													className={`w-full h-full rounded-full flex justify-center items-center`}
													style={{ background: `${e.hex}` }}>
													<Checkmark height={27} width={15} fill={e.name === "White" ? '#000' : '#FFF'} />
												</div>
												:
												<div
													className={`w-[16px] h-[16px] rounded-full`}
													style={{ background: `${e.hex}` }}>
												</div>
											}
										</div>
									</UITooltip>
								))}
						</div>
					</div>
					<div className="flex flex-col gap-4">
						<div className="font-medium tracking-wider text-[#616161] text-xs font-sans">
							Arms Size
						</div>
						<div className="flex gap-4">
							{/* <div className="flex justify-between w-[calc(100%-102px)] xsmx:w-[calc(100%-89px)]"> */}
							<div className="flex justify-between gap-2">
								{frameSizeConst.map((size) => {
										var check = true;
										if (checkVariationOnColorPicker) {
											var type = 'Arms';
											check = checkVariationOnColorPicker(type, size.short, armColor);
										}

										return (
											<div
												key={size.id}
												onClick={() => {
													setArmsSize(size.short);
												}}
												className={`${check?'':'disable-size text-[#DEDEDE]'} cursor-pointer flex items-center justify-center bg-white border rounded-md w-[54px] h-[46px] p-1 xsmx:h-[53px] ${armsSize == size.short
														? 'border-black'
														: 'border-[#CACACA] hover:border-[#AEADAD]'
													} duration-300 transition-colors`}>
												<span className="font-sans font-medium text-sm text-center xsmx:text-xs">
													{size.short}
												</span>
												{check == false?(<div className="hr"></div>):<></>}
											</div>
										) 

									})}
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
